import { FC } from 'react';

export const SkeletonPulse: FC<{ className?: string }> = ({ className }) => (
    <div className={`bg-slate-200 animate-pulse rounded ${className || ''}`} />
);

export const SkeletonKPICard: FC = () => (
    <div className="bg-white rounded-2xl p-5 border border-slate-100 min-h-[150px]">
        <div className="flex items-center gap-3 mb-3">
            <SkeletonPulse className="w-10 h-10 rounded-xl" />
            <SkeletonPulse className="h-3 w-20" />
        </div>
        <SkeletonPulse className="h-7 w-16" />
    </div>
);

export const SkeletonQuickStats: FC = () => (
    <div className="bg-slate-900 rounded-2xl p-5 border border-slate-800 h-[148px]">
        <div className="grid grid-cols-2 gap-4">
            {[1, 2, 3, 4].map(i => (
                <div key={i}>
                    <SkeletonPulse className="h-8 w-12 mb-1 bg-slate-700" />
                    <SkeletonPulse className="h-3 w-16 bg-slate-700" />
                </div>
            ))}
        </div>
    </div>
);

export const SkeletonChart: FC<{ height?: string }> = ({ height = 'h-96' }) => (
    <div className="bg-white rounded-2xl p-6 border border-slate-100">
        <div className="flex items-center justify-between mb-4">
            <SkeletonPulse className="h-4 w-32" />
            <SkeletonPulse className="h-4 w-16" />
        </div>
        <SkeletonPulse className={`w-full ${height} rounded-lg`} />
    </div>
);

export const SkeletonPipeline: FC = () => (
    <div className="bg-white rounded-2xl p-6 border border-slate-200 lg:col-span-2">
        <div className="flex items-center justify-between mb-6">
            <div>
                <SkeletonPulse className="h-5 w-48 mb-2" />
                <SkeletonPulse className="h-3 w-32" />
            </div>
            <SkeletonPulse className="h-8 w-24 rounded-full" />
        </div>
        <div className="flex items-center justify-between gap-4 mb-6">
            {[1, 2, 3, 4, 5].map(i => (
                <div key={i} className="flex-1 p-4 rounded-xl bg-slate-50 border border-slate-200">
                    <SkeletonPulse className="w-12 h-12 rounded-full mx-auto mb-3" />
                    <SkeletonPulse className="h-3 w-16 mx-auto mb-1" />
                    <SkeletonPulse className="h-2 w-10 mx-auto" />
                </div>
            ))}
        </div>
        <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-200">
            {[1, 2, 3].map(i => (
                <div key={i} className="text-center">
                    <SkeletonPulse className="h-8 w-12 mx-auto mb-1" />
                    <SkeletonPulse className="h-2 w-16 mx-auto" />
                </div>
            ))}
        </div>
    </div>
);

export const SkeletonList: FC = () => (
    <div className="bg-white rounded-2xl p-6 border border-slate-100">
        <SkeletonPulse className="h-4 w-24 mb-4" />
        <div className="space-y-3">
            {[1, 2, 3, 4, 5].map(i => (
                <div key={i} className="flex items-center gap-3 p-3 rounded-lg bg-slate-50">
                    <SkeletonPulse className="w-8 h-8 rounded-full" />
                    <div className="flex-1">
                        <SkeletonPulse className="h-3 w-32 mb-1" />
                        <SkeletonPulse className="h-2 w-20" />
                    </div>
                    <SkeletonPulse className="h-5 w-16 rounded-full" />
                </div>
            ))}
        </div>
    </div>
);
